package domain.usecase

import domain.repository.AuthenticationRepository

/**
 * Use case for handling user logout
 */
class LogoutUseCase(
    private val authRepository: AuthenticationRepository
) {
    
    /**
     * Logs out the user and clears all authentication data
     */
    suspend fun execute() {
        authRepository.logout()
    }
}
